import React from 'react'
import { Tag, TagVariant } from './Tag'

export type StatusType = 'IN_PROGRESS' | 'COMPLETED' | 'NEED_ACTION' | 'ERRORED' | 'STOPPED'

export interface StatusPillProps {
  status: StatusType
  text?: string
  className?: string
}

const getStatusVariantAndLabel = (
  status: StatusType,
  text?: string
): { variant: TagVariant; label: string } => {
  switch (status) {
    case 'COMPLETED':
      return {
        variant: 'success',
        label: text || 'Completed'
      }
    case 'NEED_ACTION':
      return {
        variant: 'warning',
        label: text || 'Input Needed'
      }
    case 'ERRORED':
    case 'STOPPED':
      return {
        variant: 'error',
        label: text || 'Error'
      }
    case 'IN_PROGRESS':
    default:
      return {
        variant: 'info',
        label: text || 'Task In Progress'
      }
  }
}

export const StatusPill: React.FC<StatusPillProps> = ({ status, text, className }) => {
  const { variant, label } = getStatusVariantAndLabel(status, text)

  return (
    <Tag variant={variant} className={className} bordered={false}>
      {label}
    </Tag>
  )
}

export default StatusPill
